export const ESCROW_APPLICATION_BANK_LIST = [
	{ key: 'bank0', value: '없음', name: '은행선택' },
	{ key: 'bank1', value: '산업', name: '산업' },
	{ key: 'bank2', value: '기업', name: '기업' },
	{ key: 'bank3', value: '국민', name: '국민' },
	{ key: 'bank4', value: '수협', name: '수협' },
	{ key: 'bank5', value: '농협', name: '농협' },
	{ key: 'bank6', value: '우리', name: '우리' },
	{ key: 'bank7', value: '제일', name: '제일' },
	{ key: 'bank8', value: '씨티', name: '씨티' },
	{ key: 'bank9', value: '대구', name: '대구' },
	{ key: 'bank10', value: '부산', name: '부산' },
	{ key: 'bank11', value: '광주', name: '광주' },
	{ key: 'bank12', value: '제주', name: '제주' },
	{ key: 'bank13', value: '전북', name: '전북' },
	{ key: 'bank14', value: '경남', name: '경남' },
	{ key: 'bank15', value: '새마을금고', name: '새마을금고' },
	{ key: 'bank16', value: '신협', name: '신협' },
	{ key: 'bank17', value: '우체국', name: '우체국' },
	{ key: 'bank18', value: '하나', name: '하나' },
	{ key: 'bank19', value: '신한', name: '신한' },
];

export const ESCROW_NOMINEE_TYPE = {
	MAIN_APPLICANT_NOMINEE: 'MAIN_APPLICANT_NOMINEE',
	SUB_APPLICANT_NOMINEE: 'SUB_APPLICANT_NOMINEE',
};

export const ESCROW_APPLICANT_TYPE = {
	PERSONAL: 'PERSONAL',
	PERSONAL_BUSINESS: 'PERSONAL_BUSINESS',
	CORPORATION_BUSINESS: 'CORPORATION_BUSINESS',
};

export const APPLICATION_TYPE = {
	HOME_SERVICE: 'HOME_SERVICE',
	ESCROW: 'ESCROW',
};

export const ESCROW_CASH_PAY_STATUS_KEY = 'escrow_cash_pay';
